export const mapProject = (project: IProject): IDeliveryAddress => {
  return {
    addressSummary: `${project.address1}, ${project.city}`,
    deliveryAddress1: project.address1,
    deliveryAddress2: project.address2,
    deliveryZip: project.zip,
    deliveryCountry: project.country,
    deliveryCity: project.city,
    longitude: project.longitude,
    latitude: project.latitude,
    projectId: project.id,
    project
  }
}

export const attributeNames = {
  address1: 'deliveryAddress1',
  address2: 'deliveryAddress2',
  city: 'deliveryCity',
  zip: 'deliveryZip',
  country: 'deliveryCountry',
  latitude: 'latitude',
  longitude: 'longitude'
}
